import React from "react";
// assets
import AccountMultiple from "../../assets/images/icons/AccountMultiple";
import CastEducation from "../../assets/images/icons/CastEducation";
import ChartDonut from "../../assets/images/icons/ChartDonut";
import CogOutline from "../../assets/images/icons/CogOutline";
import CreditCard from "../../assets/images/icons/CreditCard";
import FeedbackIcon from "../../assets/images/icons/FeedbackIcon";
import FinanceIcon from "../../assets/images/icons/FinanceIcon";
import Newspaper from "../../assets/images/icons/Newspaper";
import School from "../../assets/images/icons/School";
import SurveyIcon from "../../assets/images/icons/SurveyIcon";
import TasksIcon from "../../assets/images/icons/TasksIcon";
import UserAlternativeIcon from "../../assets/images/icons/UserAlternativeIcon";
import ManagmentIcon from "../../assets/images/icons/ManagmentIcon";
import OrderPageIcon from "../../assets/images/icons/OrderPageIcon";
import GroupIcon from "../../assets/images/icons/GroupIcon";
import browserStorage from "../../services/storage";
// layout size
export const sidebarWidth = "173px";
export const headerHeight = "56px";


  // const organizationCheck = browserStorage.getParse<any>("organizationCheck");


export const language = [
  {
    value: "uz",
    label: "O'zbekcha",
  },
  {
    value: "ru",
    label: "Русский",
  },
  {
    value: "en",
    label: "English",
  },
];

export const sideItems = [
  {
    id: "getEmployeeTask",
    title: "TASKS",
    icon: <TasksIcon />,
    showKey: "employeeTask",
    collapse: false,
    active: false,
    path: "/tasks/list",
    child: ["/tasks/type-list"],
    multi: false,
  },

  {
    id: "orders",
    title: "LIDS",
    icon: <OrderPageIcon />,
    showKey: "orders",
    collapse: false,
    multi: false,
    children: [
      {
        id: "getOrder",
        active: false,
        title: "ORDER_LIST",
        path: "/orders/order-list",
        child: ["/orders/order-list/edit/:id/:orderId"],
      },
      {
        id: "getComeOrder",
        active: false,
        title: "COME_ORDER",
        path: "/orders/come-orders",
      },
    ],
  },

  {
    id: "group",
    title: "GROUP",
    collapse: false,
    icon: <GroupIcon />,
    showKey: "group",
    multi: false,
    children: [
      {
        id: "getGroup",
        title: "GROUP",
        active: false,
        path: "/group/groups",
        child: [
          "/group/groups/details/:id",
          "/group/groups/history/:id",
          "/group/groups/attendance/:id",
          "/group/groups/template",
          "/group/groups/details/template/:id",
        ],
      },
      {
        id: "getGroup",
        title: "ALL_TASKS",
        active: false,
        path: "/group/tasks",
      },
      {
        id: "getTimetable",
        title: "TIME_TABLE",
        active: false,
        path: "/group/class-schedule",
      },
      {
        id: "getRoom",
        title: "ROOMS",
        active: false,
        path: "/group/rooms",
      },
      {
        id: "getGroupStudents",
        title: "GROUP_STUDENTS",
        active: false,
        path: "/group/group-students",
      },
      // {
      //   id: "totalPriceGroupStudent",
      //   title: "STUDENT_CALCULATOR",
      //   active: false,
      //   path: "S",
      // },
    ],
  },

  {
    id: "student",
    title: "STUDENT",
    icon: <School />,
    showKey: "student",
    collapse: false,
    multi: false,
    children: [
      {
        id: "getNewStudents",
        active: false,
        title: "NEW_STUDENT_LIST",
        path: "/orders/new-student-list",
      },
      {
        id: "getActiveStudents",
        title: "ACTIVE",
        active: false,
        path: "/students/active",
      },
      {
        id: "getArchiveStudents",
        title: "ARCHIVE",
        active: false,
        path: "/students/archive",
      },
      {
        id: "getStudent",
        title: "STUDENT_LIST",
        active: false,
        path: "/students/student-list",
        child: [
          "/students/balance-history/:id",
          "/students/student-list/edit/:id",
          "/students/student-list/template",
        ],
      },

      {
        id: "getStudentParents",
        title: "PARENT",
        active: false,
        path: "/students/parent",
      },
    ],
  },

  {
    id: "createOnlineCourse",
    title: "STUDY_DEPARTMENT",
    icon: <CreditCard />,
    showKey: "course",
    collapse: false,
    multi: false,
    children: [
      {
        id: "getCourse",
        active: false,
        title: "OFFLINE_COURSES",
        path: "/course/courses",
        showKey: "course",
        child: [
          "/course/courses/add",
          "/course/details/:id",
          "/course/courses/level-edit/:id",
        ],
      },
      {
        id: "createOnlineCourse",
        active: false,
        title: "ONLINE_COURSE",
        path: "/online-course",
        showKey: "onlineCourse",
        child: ["/online-course/clients/:id", "/online-course/add"],
      },
      {
        id: "createOnlineCourseCategory",
        active: false,
        title: "CATEGORY",
        showKey: "onlineCourse",
        path: "/online-course-category",
        child: ["/online-course-category/:id"],
      },
    ],
  },

  {
    id: "cashbox",
    title: "FINANCE",
    icon: <FinanceIcon />,
    showKey: "finance",
    collapse: false,
    multi: true,
    children: [
      {
        id: ["cashbox", "bonus", "penaltyGetAll", "getStudentContract"],
        title: "ACTIONS",
        active: false,
        children: [
          {
            id: "cashbox",
            title: "CASHES",
            path: "/finance/cash",
            active: false,
            child: [
              "/finance/shifts/history",
              "/finance/shifts/history/check/:id",
            ],
          },
          {
            id: "bonus",
            title: "BONUS",
            active: false,
            path: "/finance/bonus",
          },
          {
            id: "penaltyGetAll",
            title: "PENALTY",
            active: false,
            path: "/finance/penalty",
          },
          {
            id: "getStudentContract",
            title: "SALARY",
            active: false,
            path: "/finance/salary",
          },
          // ...(organizationCheck?.studentChargingSistem === "aboniment"
          // ? [
          //     {
          //       id: "getAboniment",
          //       title: "SUBSCRIPTION",
          //       active: false,
          //       path: "/finance/aboniment",
          //     },
          //   ]
          // : organizationCheck?.studentChargingSistem === "byAttendance"
          // ? [
          //     {
          //       id: "getByAttendance",
          //       title: "ATTENDANCE",
          //       active: false,
          //       path: "/finance/attendance",
          //     },
          //   ]
          // : []),
        ],
      },
      {
        id: ["getFinanceAnalitics", "getStudentContract"],
        title: "REPORTS",
        active: false,
        children: [
          {
            id: "getStudentContract",
            title: "SALARY_BALANCE",
            active: false,
            path: "/finance/balance",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "INCOME_OUTPUT",
            path: "/analytics/finance",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "INCOME_PLAN",
            path: "/analytics/income-plan",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "ANALYTICS_UNPAID",
            path: "/analytics/unpaid",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "ANALYTICS_DIFFERENT",
            path: "/analytics/different",
          },
        ],
      },
      {
        id: ["getShiftTransaction", "getStudentContract"],
        title: "DATAS",
        showKey: "finance",
        active: false,
        children: [
          {
            id: "getShiftTransaction",
            title: "PAYMENT_TYPE",
            active: false,
            path: "/finance/payment-type",
            child: [
              "/finance/payment-type/add",
              "/finance/payment-type/edit/:id",
            ],
          },
          {
            id: "getStudentContract",
            title: "CONTRACT",
            active: false,
            path: "/finance/contract",
          },
        ],
      },
    ],
  },

  {
    id: "hr",
    title: "CONTROL",
    icon: <FeedbackIcon />,
    showKey: "feedback",
    collapse: false,
    active: false,
    multi: true,
    children: [
      {
        id: ["feedback", "getStudentAttendance"],
        title: "ACTIONS",
        showKey: "employees",
        active: false,
        children: [
          {
            id: "getStudentAttendance",
            title: "ATTENDANCE",
            active: false,
            path: "/students/attendance",
          },
          {
            id: "feedback",
            title: "FEEDBACK",
            active: false,
            path: "/feedback",
            child: [],
          },
        ],
      },
      {
        id: ["getTeacherLessonRates", "getAnaliticsstatistics"],
        title: "REPORTS",
        showKey: "employees",
        active: false,
        children: [
          {
            id: "getTeacherLessonRates",
            title: "EMPLOYEES_RATINGS",
            active: false,
            path: "/hr/employees/ratings",
          },
          {
            id: "getAnaliticsstatistics",
            title: "NOT_ATTENDET_GROUP",
            active: false,
            path: "/analytics/not-attended",
          },
          {
            id: "getAnaliticsstatistics",
            active: false,
            title: "STATUS_OF_BRANCHES",
            path: "/monitoring/statistics",
          },


          ////////////////////////////////////////////////////////////////
        ],
      },
    ],
  },

  {
    id: "hr",
    title: "MANAGMENT",
    icon: <ManagmentIcon />,
    showKey: "employees",
    collapse: false,
    multi: false,
    children: [
      {
        id: "getEmployee",
        title: "EMPLOYEES",
        active: false,
        path: "/hr/employees",
        child: ["/hr/employees/profile/:id"],
      },
      {
        id: "getRole",
        title: "ROLES",
        active: false,
        path: "/hr/roles",
        child: ["/hr/roles/add", "/hr/roles/edit/:id"],
      },
      {
        id: "getBranch",
        title: "BRANCHES",
        active: false,
        path: "/branches",
        child: ["/branches/add", "/branches/edit/:id", "/branches/template"],
      },
    ],
  },

  {
    id: "news",
    title: "SALES_AND_MARKETING",
    icon: <Newspaper />,
    showKey: "marketing",
    collapse: false,
    multi: false,
    children: [
      {
        id: "getSurvey",
        title: "MARKETING",
        // icon: <SurveyIcon />,
        // showKey: "marketing",
        // collapse: false,
        active: false,
        path: "/marketing/surveys",
      },
      {
        id: "getNews",
        title: "NEWS",
        active: false,
        path: "/news/news-list",
        child: ["/news/news-list/add", "/news/news-list/edit/:id"],
      },
      {
        id: "getSmsT",
        title: "SMS_TEMPLATE",
        active: false,
        path: "/news/sms-template",
      },
      {
        id: "getSms",
        title: "SMS",
        active: false,
        path: "/news/sms",
      },
    ],
  },

  {
    id: "analytics",
    title: "REPORTS",
    icon: <ChartDonut />,
    showKey: "analitics",
    collapse: false,
    multi: true,
    children: [
      {
        id: ["getOrderAnalitics", "getFinanceAnalitics"],
        title: "SALES_AND_MARKETING",
        active: false,
        children: [
          {
            id: "getOrderAnalitics",
            active: false,
            title: "SALE_VORONKA",
            path: "/analytics/order",
            child: ["/analytics/order", "/analytics/order/:id"],
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "CANCEL_REASON",
            path: "/analytics/left-reasons",
          },
        ],
      },
      {
        id: ["getStudentContract", "getFinanceAnalitics"],
        title: "FINANCE",
        active: false,
        children: [
          {
            id: "getStudentContract",
            title: "SALARY_BALANCE",
            active: false,
            path: "/reports/finance/balance",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "INCOME_OUTPUT",
            path: "/reports/analytics/finance",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "INCOME_PLAN",
            path: "/reports/analytics/income-plan",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "ANALYTICS_UNPAID",
            path: "/reports/analytics/unpaid",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "ANALYTICS_DIFFERENT",
            path: "/reports/analytics/different",
          },
          {
            id: "getFinanceAnalitics",
            active: false,
            title: "CANCEL_PAYMENT",
            path: "/analytics/cancelled-transactions",
          },
        ],
      },
      {
        id: ["getAnaliticsstatistics", "reasonAnaliticsChart"],
        title: "STUDY",
        active: false,
        children: [
          {
            id: "getAnaliticsstatistics",
            active: false,
            title: "TEACHER_SAMARADORY",
            path: "/analytics/teacher",
          },
          {
            id: "getAnaliticsstatistics",
            active: false,
            title: "ADMINSTARATOR_SAMARADORY",
            path: "/analytics/moderator/student",
          },
          {
            id: "reasonAnaliticsChart",
            active: false,
            title: "REASON_OF_CANCEL",
            path: "/statistics",
          },
          {
            id: "getAnaliticsstatistics",
            active: false,
            title: "ROOMS_ANALYTICS",
            path: "/analytics/rooms",
          },
          {
            id: "getAnaliticsstatistics",
            active: false,
            title: "EARNING_TO",
            path: "/analytics/earned-analytics",
          },
        ],
      },
      {
        id: ["getAnaliticsstatistics", "getTeacherLessonRates"],
        title: "CONTROL",
        active: false,
        children: [
          {
            id: "getAnaliticsstatistics",
            active: false,
            title: "STATUS_OF_BRANCHES",
            path: "/reports/monitoring/statistics",
          },
          {
            id: "getTeacherLessonRates",
            title: "EMPLOYEES_RATINGS",
            active: false,
            path: "/reports/hr/employees/ratings",
          },
          {
            id: "getTeacherLessonRates",
            title: "NOT_ATTENDET_GROUP",
            active: false,
            path: "/reports/analytics/not-attended",
          },
        ],
      },
    ],
  },

  {
    id: "settings",
    title: "SETTINGS",
    icon: <CogOutline />,
    showKey: "settings",
    collapse: false,
    multi: false,
    children: [
      {
        id: [
          { id: "getReceipt" },
          { id: "getBranch" },
          { id: "getSurvey" },
          { id: "getOrderStatus" },
        ],
        title: "GENERAL_SYSTEMS",
        active: false,
        path: "/settings/system",
        child: ["/settings/branch/add", "/settings/branch/edit/:id"],
      },

      {
        id: [{ id: "getOverpayment" }, { id: "getLevel" }],
        title: "FINANCE",
        active: false,
        path: "/settings/finance",
      },
      {
        id: [
          { id: "getOverpayment" },
          { id: "getTeacherSalary" },
          { id: "getLevel" },
        ],
        title: "STUDY",
        active: false,
        path: "/settings/study",
      },
      {
        id: [{ id: "getStudentBonus" }, { id: "getStudentCategory" }],
        title: "SALE_MARKETING",
        active: false,
        path: "/settings/sale-marketing",
      },

      {
        id: [{ id: "getActivities" }],
        title: "MANAGE",
        active: false,
        path: "/settings/management",
      },
      {
        id: [{ id: "integration" }],
        title: "INTEGRATION",
        active: false,
        path: "/settings/integration",
        child: ["/settings/integration", "/settings/integration/:id"],
      },
    ],
  },
];
